import AuthRoutes from './AuthRoutes'

const publicRoutes = [...AuthRoutes]

export default publicRoutes
